import { render, staticRenderFns } from "./rulePage.vue?vue&type=template&id=6230181c&scoped=true"
import script from "./rulePage.vue?vue&type=script&lang=js"
export * from "./rulePage.vue?vue&type=script&lang=js"
import style0 from "./rulePage.vue?vue&type=style&index=0&id=6230181c&prod&lang=scss&scoped=true"
import style1 from "./rulePage.vue?vue&type=style&index=1&id=6230181c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230181c",
  null
  
)

export default component.exports